export const environment = {
  production: false,
  apiUrl: 'https://qauaxi.net/api/v1',
  socketUrl: 'https://qauaxi.net',
  socketGatewayOrigin: undefined as string | undefined,
  ASSETS_URL: 'https://uaxis3.s3.us-east-1.amazonaws.com/uaxis3/',
  urlUbica: 'https://ubica.qauaxi.net/',
  googleMapsApiKey: 'AIzaSyD5uXYuRgFLxeYfUrT0eNvC0efN1Ug_hqA',
};
